import React, { useContext } from "react";
import styles from "@/page-components/budgets/components/budgets.module.css";
import { TaggingContext } from "../tagging-context-file";

const DeleteConfirmationSection = ({
  name,
  deleteLoading,
  setTriggerDelete,
}) => {
  const context = useContext(TaggingContext);
  const Conformation = (id) => {
    context?.setSelectedTagID(id);
  };

  return (
    <div className={styles.dialogContainer}>
      <div>
        <div className={styles.dialogTitle}>Delete {name}</div>
        <span className={styles.dialogBody}>
          Are you sure you want to delete this {name}?
          <div>This action cannot be undone.</div>
        </span>
      </div>
      <div className={styles.buttonContainer}>
        <button
          className={styles.deleteButton}
          onClick={()=>Conformation(context?.DeleteData)}
          // onClick={() => {
          //   context?.setSelectedTagID(context?.DeleteData);
          //   setTriggerDelete((prev) => !prev);
          // }}
        >
          {deleteLoading ? "Deleting..." : "Delete"}
        </button>
        <button
          className={styles.cancleButton}
          onClick={() => context?.setConfirmationmodal(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteConfirmationSection;
